module.exports = __webpack_public_path__ + "static/media/facebook-w.34138cd1.svg";